if(document.body.classList.contains('template-article')) {

  const articleSliderEl = document.getElementById('article-slider')

  let articleSlider = null

  const toggleSlider = document.getElementById('toggle-slider')
  const toggleThumbnails = document.getElementById('toggle-thumbnails')

  if(articleSliderEl) {

    const sliderOptions = {
      arrows: true,
      autoWidth: true,
      pagination: false
    }
    articleSlider = new Splide( articleSliderEl, sliderOptions ).mount()

    toggleThumbnails.addEventListener('click', (e) => {
      articleSlider.destroy()
      articleSliderEl.classList.add('thumbnails')
      toggleThumbnails.disabled = true
      toggleSlider.disabled = false
    })

    toggleSlider.addEventListener('click', (e) => {
      articleSliderEl.classList.remove('thumbnails')
      articleSlider = new Splide( articleSliderEl, sliderOptions ).mount()
      toggleThumbnails.disabled = false
      toggleSlider.disabled = true
    })

    // destroy on mobile
    if(window.matchMedia('(max-width: 600px)').matches) {
      articleSlider.destroy()
    }

  }

}